import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const UserService = {};

UserService.getUsers = function (params) {
  return fetch({
    url: ApiConstant.USER_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
UserService.downalodUserExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.USER_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids }
  });
};
UserService.addUser = function (data, params) {
  return fetch({
    url: ApiConstant.USER_CREATION,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
UserService.editUser = function (params, data) {
  return fetch({
    url: ApiConstant.USER_UPDATE,
    method: "PUT",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
UserService.editUserStatus = function (data, status) {
  const payload = {
    status: status,
    user_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.USER_STATUS_UPDATE,
    method: "PUT",
    data: payload,
  });
};
UserService.getSingleUser = function (params, data) {
  return fetch({
    url: ApiConstant.USER_SINGLE,
    method: "get",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};


export default UserService;
